<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h5 class="mb-0">{{ $t('monthly_attendance_calendar') }}</h5>
                        <p>Composant chargé avec succès !</p>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <div class="btn-group" role="group">
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-primary"
                                        @click="previousMonth"
                                    >
                                        <i class="fas fa-chevron-left"></i>
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-primary"
                                    >
                                        {{ currentMonthName }}
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-outline-primary"
                                        @click="nextMonth"
                                    >
                                        <i class="fas fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <button 
                                    type="button" 
                                    class="btn btn-success"
                                    @click="loadData"
                                >
                                    <i class="fas fa-sync"></i>
                                    Charger données
                                </button>
                            </div>
                        </div>

                        <div v-if="preLoader" class="text-center">
                            <p>Chargement en cours...</p>
                        </div>

                        <div v-else>
                            <p>Données chargées : {{ employees.length }} employés trouvés</p>
                            <p>Mois actuel : {{ currentMonthName }}</p>
                            <p>Jours dans le mois : {{ daysInMonth.length }}</p>
                        </div>

                        <!-- Table simple pour test -->
                        <div class="table-responsive mt-3" v-if="employees.length > 0">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Employé</th>
                                        <th v-for="day in daysInMonth.slice(0, 7)" :key="day.date">
                                            {{ day.day }}/{{ selectedMonth + 1 }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="employee in employees.slice(0, 5)" :key="employee.id">
                                        <td>{{ employee.full_name }}</td>
                                        <td v-for="day in daysInMonth.slice(0, 7)" :key="`${employee.id}-${day.date}`">
                                            <span :class="getAttendanceClass(employee.id, day.date)">
                                                <i :class="getAttendanceIcon(employee.id, day.date)"></i>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import { ATTENDANCE_DAILY_EMPLOYEE_DETAILS } from '../../../Config/ApiUrl';

export default {
    extends: CoreLibrary,
    name: "MonthlyAttendanceCalendar",
    data() {
        return {
            currentDate: new Date(),
            selectedYear: new Date().getFullYear(),
            selectedMonth: new Date().getMonth(),
            employees: [],
            attendanceData: {},
            monthNames: [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ]
        }
    },
    computed: {
        currentMonthName() {
            return `${this.monthNames[this.selectedMonth]} ${this.selectedYear}`;
        },
        
        daysInMonth() {
            const year = this.selectedYear;
            const month = this.selectedMonth;
            const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
            const days = [];
            const today = new Date();
            
            for (let day = 1; day <= daysInCurrentMonth; day++) {
                const date = new Date(year, month, day);
                const dateString = date.toISOString().split('T')[0];
                const dayOfWeek = date.getDay();
                
                days.push({
                    day: day,
                    date: dateString,
                    dayName: this.getDayName(dayOfWeek),
                    isWeekend: dayOfWeek === 0 || dayOfWeek === 6,
                    isToday: this.isSameDay(date, today)
                });
            }
            
            return days;
        }
    },
    mounted() {
        console.log('MonthlyAttendanceCalendar monté avec succès');
        this.loadData();
    },
    methods: {
        previousMonth() {
            if (this.selectedMonth === 0) {
                this.selectedMonth = 11;
                this.selectedYear--;
            } else {
                this.selectedMonth--;
            }
            this.loadData();
        },
        
        nextMonth() {
            if (this.selectedMonth === 11) {
                this.selectedMonth = 0;
                this.selectedYear++;
            } else {
                this.selectedMonth++;
            }
            this.loadData();
        },
        
        async loadData() {
            try {
                this.preLoader = true;
                console.log('Chargement des données...');
                
                // Charger seulement quelques jours pour tester
                const testDays = this.daysInMonth.slice(0, 7);
                
                for (const day of testDays) {
                    await this.loadDayData(day.date);
                }
                
                console.log('Données chargées:', this.employees.length, 'employés');
                
            } catch (error) {
                console.error('Erreur lors du chargement des données:', error);
            } finally {
                this.preLoader = false;
            }
        },
        
        async loadDayData(date) {
            try {
                let url = `${ATTENDANCE_DAILY_EMPLOYEE_DETAILS}?date=${date}`;
                console.log('Chargement pour la date:', date, 'URL:', url);
                
                const response = await this.axiosGet(url);
                console.log('Réponse reçue:', response);
                
                // Première fois qu'on charge - initialiser la liste des employés
                if (Object.keys(this.attendanceData).length === 0 && response.data.employees) {
                    this.employees = response.data.employees.map(emp => ({
                        id: emp.id,
                        full_name: emp.full_name,
                        matricule: emp.matricule,
                        department: emp.department
                    }));
                }
                
                // Stocker les données de présence pour ce jour
                if (!this.attendanceData[date]) {
                    this.attendanceData[date] = {};
                }
                
                if (response.data.employees) {
                    response.data.employees.forEach(emp => {
                        this.attendanceData[date][emp.id] = {
                            status: emp.status,
                            is_late: emp.is_late,
                            is_early_departure: emp.is_early_departure,
                            first_check_in: emp.first_check_in,
                            last_check_out: emp.last_check_out,
                            total_hours: emp.total_hours
                        };
                    });
                }
                
            } catch (error) {
                console.error(`Erreur lors du chargement des données pour ${date}:`, error);
            }
        },
        
        getAttendanceClass(employeeId, date) {
            const dayData = this.daysInMonth.find(d => d.date === date);
            if (dayData && dayData.isWeekend) {
                return 'text-muted';
            }
            
            const attendance = this.attendanceData[date]?.[employeeId];
            if (!attendance) return 'text-muted';
            
            if (attendance.status === 'absent') return 'text-danger';
            if (attendance.is_late) return 'text-warning';
            if (attendance.status === 'present' || attendance.status === 'completed') return 'text-success';
            
            return 'text-secondary';
        },
        
        getAttendanceIcon(employeeId, date) {
            const dayData = this.daysInMonth.find(d => d.date === date);
            if (dayData && dayData.isWeekend) {
                return 'fas fa-calendar-times';
            }
            
            const attendance = this.attendanceData[date]?.[employeeId];
            if (!attendance) return 'fas fa-question';
            
            if (attendance.status === 'absent') return 'fas fa-times';
            if (attendance.is_late) return 'fas fa-exclamation-triangle';
            if (attendance.status === 'present' || attendance.status === 'completed') return 'fas fa-check';
            
            return 'fas fa-minus';
        },
        
        getDayName(dayOfWeek) {
            const days = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
            return days[dayOfWeek];
        },
        
        isSameDay(date1, date2) {
            return date1.getDate() === date2.getDate() &&
                   date1.getMonth() === date2.getMonth() &&
                   date1.getFullYear() === date2.getFullYear();
        }
    }
}
</script>

<style scoped>
.card {
    border-radius: var(--mozali-radius-lg);
    box-shadow: var(--mozali-shadow-card);
}

.btn-group button {
    border-radius: var(--mozali-radius-sm);
    transition: transform var(--mozali-motion-micro) var(--mozali-motion-ease);
}

.btn-group button:hover {
    transform: translateY(-2px);
}

.table th, .table td {
    vertical-align: middle;
    text-align: center;
}

.text-success {
    color: var(--mozali-color-cyan) !important;
}

.text-danger {
    color: var(--mozali-color-danger) !important;
}

.text-warning {
    color: var(--mozali-color-brand-dark) !important;
}

.text-info {
    color: var(--mozali-color-brand) !important;
}

.text-muted {
    color: var(--mozali-color-gray-600) !important;
}

@media (prefers-reduced-motion: reduce) {
    .btn-group button {
        transition: none !important;
    }

    .btn-group button:hover {
        transform: none !important;
    }
}
</style>
